export default __webpack_public_path__ + "static/media/6.c5491802.jpg";